import _ from 'lodash';

import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import type { PermissionsParsed } from 'bundles/user-permissions/src/utils/types';

export const parsePermissions = (permissions: Record<string, string>): PermissionsParsed => {
  return _.reduce(
    permissions,
    (acc: PermissionsParsed, grantStatus: string, permission: string) => {
      const split = permission.replace('(', '').replace(')', '').split(',');
      // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      const instance = stringKeyToTuple(split[0])[1];
      // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      const noun = stringKeyToTuple(split[1])[1];
      // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
      const verb = stringKeyToTuple(split[2])[1];

      // From the perspective of the FE, an absence of a permission is the same as being denied authorization.
      if (_.toUpper(grantStatus) === 'GRANTED') {
        // Some indentifiers, like a partner id, are numeric...
        // @ts-expect-error TS2769 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        _.setWith(
          acc,
          [noun, verb, instance],
          grantStatus,
          // ...this prevents array creation with the instance ids that are `number`s and not `string`s.
          Object
        );
      }

      return acc;
    },
    {}
  );
};
